import styled from 'styled-components';
import { breakpoints } from '@bnnvara/breakpoints';

export const AccordionContainer = styled.div`
  padding: 32px 16px;
  background: ${({ theme }) => theme.tertiary.light};

  ${breakpoints.md} {
    padding: 40px 40px 80px;
  }
`;

export const AccordionGroupTitle = styled.h2`
  font-size: 26px;
  line-height: 1.5;
  margin: 0;
  font-weight: 900;

  ${breakpoints.md} {
    font-size: 36px;
    margin: 0 0 32px;
  }
`;

export const AccordionItem = styled.div`
  > .MuiPaper-root {
    background: transparent;
    box-shadow: none;

    &:after {
      content: '';
      position: absolute;
      width: 100%;
      bottom: 0;
      left: 0;
      right: 0;
      height: 1px;
      background: ${({ theme }) => theme.tertiary.dark};
    }
  }

  .MuiButtonBase-root {
    padding: 0;

    &.MuiAccordionSummary-root,
    &.Mui-expanded {
      min-height: inherit;
    }

    > .MuiAccordionSummary-expandIconWrapper {
      svg {
        width: 16px;
        height: 16px;
      }

      &.Mui-expanded {
        transform: rotate(45deg);
      }
    }
  }

  .MuiAccordionSummary-content {
    margin: 16px 0;

    &.Mui-expanded {
      min-height: inherit;
    }
  }

  .MuiCollapse-wrapper {
    padding-bottom: 16px;
  }

  .MuiAccordionDetails-root {
    padding: 0;

    > p,
    > h2,
    > h3,
    > h4,
    > h5,
    > h6 {
      margin-bottom: 16px;
    }

    > ul {
      margin: 16px 0 0 16px;
    }
  }

  // @TODO global fix for this,
  a {
    text-decoration: underline;
  }
`;

export const Summary = styled.span`
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
`;
